//@flow
/*
  ParsedCollection class includes a parse function base on the current response
  format of the magento api {id1: {attributes object}, id2: {attributes object}}
*/
import BaseCollection from './baseCollection';
import _ from 'underscore';
import type Model from '../Model/model';

export default class ParsedCollection<ModelObject: Object, T:Model<ModelObject>> extends BaseCollection<ModelObject, T, {[any]:$Shape<ModelObject>}>{

  __parse(modelsAttrs:?{[any]:ModelObject}):ModelObject[] {
    const models = [];
    _.each(modelsAttrs, (model) => { models.push(model); });
    return models;
  }
}
